import { get } from 'lodash';
import createFeatureAwareFactory from '@/js/feature-toggles/feature-factory';
import {
    toSentenceCase,
    suffixWithColon,
    toAllUppercaseCase,
    toCamelCase,
} from '../utils/string-utils';
import i18n from '@/js/vue-i18n';
import store from '@/js/store';

const formatNumber = (format, number) => {
    const toggleLogic = get(store.state, 'clientConfig.toggleLogic');
    const featureAwareFactory = createFeatureAwareFactory(toggleLogic);
    return featureAwareFactory.getFormatNumberFunction()(format, number);
};

const formatNumberShorthand = (format, number) => {
    return i18n.n(format, number);
};

const countNumber = num => i18n.n('numbers.default.countNumber', num);
const efficiencyPercentage = num => i18n.n('numbers.default.efficiencyPercentage', num);
const marginPercentage = num => i18n.n('numbers.default.marginPercentage', num);
const forecastedVolume = num => formatNumber('numbers.default.forecastedVolume', num);
const forecastedIncrementalTraffic = num =>
    formatNumber('numbers.default.forecastedIncrementalTraffic', num);
const lumpFundingTotal = num => formatNumber('numbers.default.lumpFundingTotal', num);
const forecastedSales = num => formatNumber('numbers.default.forecastedSales', num);
const forecastedMargin = num => formatNumber('numbers.default.forecastedMargin', num);
const incrementalMargin = num => formatNumber('numbers.default.incrementalMargin', num);
const totalSales = num => formatNumber('numbers.default.totalSales', num);
const totalMargin = num => formatNumber('numbers.default.totalMargin', num);
const numberShorthand = num => formatNumberShorthand('numbers.default.numberShorthand', num);
const currencyShorthand = num => formatNumberShorthand('numbers.default.currencyShorthand', num);
const currency = num => formatNumber('numbers.default.currency', num);
const currencyNoLabel = num => formatNumber('numbers.default.currencyNoLabel', num);
const currencyNoLabelPadded = num => formatNumber('numbers.default.currencyNoLabelPadded', num);
const currencyNoLabelPadded3dp = num =>
    formatNumber('numbers.default.currencyNoLabelPadded3dp', num);
const percentageWith1Decimal = num => formatNumber('numbers.default.percentageWith1Decimal', num);
const percentageWithDecimals = num => formatNumber('numbers.default.percentageWithDecimals', num);
const currencyRounded = num => i18n.n('numbers.default.currencyRounded', num);
const defaultNumber = num => i18n.n('numbers.default.number', num);
const overwrittenVolumeEntry = num => i18n.n('numbers.default.overwrittenVolumeEntry', num);

export {
    toSentenceCase,
    suffixWithColon,
    toAllUppercaseCase,
    toCamelCase,
    countNumber,
    efficiencyPercentage,
    marginPercentage,
    forecastedVolume,
    forecastedIncrementalTraffic,
    lumpFundingTotal,
    forecastedSales,
    forecastedMargin,
    incrementalMargin,
    totalSales,
    totalMargin,
    numberShorthand,
    currencyShorthand,
    currency,
    currencyNoLabel,
    currencyNoLabelPadded,
    currencyNoLabelPadded3dp,
    percentageWith1Decimal,
    percentageWithDecimals,
    currencyRounded,
    defaultNumber,
    overwrittenVolumeEntry,
};
